// Audited against all 300 original portraits and the creator's mouth reference sheet.
// See docs/portrait-metadata.md. Filenames guard against applying this audit to other art.
export default {
  "#1": {"url": "#1 RedPutin Keeper CapNaka.png", "mouth": "Classic"},
  "#2": {"url": "#2 Place FSB Naka.png", "mouth": "Classic"},
  "#3": {"url": "#3 Melancholia Dank HoodedNaka.png", "mouth": "Pepejointsph"},
  "#4": {"url": "#4 Place 3D PeakyNaka.png", "mouth": "Drink"},
  "#5": {"url": "#5 Hairpepe Classic HoodedNaka.png", "mouth": "Drink"},
  "#6": {"url": "#6 Bitcoin Sun MinerNaka.png", "mouth": "Pepeomuerte"},
  "#7": {"url": "#7 Moon Blaine KekLordNaka.png", "mouth": "Classic"},
  "#8": {"url": "#8 CP Dank KekLordNaka.png", "mouth": "Pepejointsph"},
  "#9": {"url": "#9 Redputin Classic PeakyNaka.png", "mouth": "Pepeomuerte"},
  "#10": {"url": "#10 Mondrian Keeper HoodedNaka.png", "mouth": "Pepeomuerte"},
  "#11": {"url": "#11 Hairpepe Frogbus HoodedNaka.png", "mouth": "Classic"},
  "#12": {"url": "#12 Melancholia Sun HairNaka.png", "mouth": "Pepejointsph"},
  "#13": {"url": "#13 Modern Frogbus MinerNaka.png", "mouth": "Classic"},
  "#14": {"url": "#14 Modern Dank HoodedNaka.png", "mouth": "Pepeomuerte"},
  "#15": {"url": "#15 Bitcoin Sun Naka.png", "mouth": "Pepeomuerte"},
  "#16": {"url": "#16 Hairpepe 3D MinerNaka.png", "mouth": "Pepeomuerte"},
  "#17": {"url": "#17 Gox Sun Naka.png", "mouth": "Pepetown"},
  "#18": {"url": "#18 Place Pepecash PeakyNaka.png", "mouth": "Classic"},
  "#19": {"url": "#19 Modern Classic KingNaka.png", "mouth": "Pepeomuerte"},
  "#20": {"url": "#20 Djpepe FSB MinerNaka.png", "mouth": "Classic"},
  "#21": {"url": "#21 Modern Pepecash KingNaka.png", "mouth": "Pepeomuerte"},
  "#22": {"url": "#22 CP 3D Naka.png", "mouth": "Pepetown"},
  "#23": {"url": "#23 Homer Pepecash ClubNaka.png", "mouth": "Drink"},
  "#24": {"url": "#24 Redputin Dank RadioNaka.png", "mouth": "Pepetown"},
  "#25": {"url": "#25 CP Jihan KekLordNaka.png", "mouth": "Classic"},
  "#26": {"url": "#26 Djpepe Jihan KingNaka.png", "mouth": "Classic"},
  "#27": {"url": "#27 Hairpepe Frogbus ClubNaka.png", "mouth": "Classic"},
  "#28": {"url": "#28 Bitcoin Classic KekLordNaka.png", "mouth": "Classic"},
  "#29": {"url": "#29 Gox Pepecash ClubNaka.png", "mouth": "Classic"},
  "#30": {"url": "#30 Melancholia Classic MinerNaka.png", "mouth": "Pepeomuerte"},
  "#31": {"url": "#31 CP Blaine HairNaka.png", "mouth": "Drink"},
  "#32": {"url": "#32 CP Jihan CapNaka.png", "mouth": "Classic"},
  "#33": {"url": "#33 Homer Sun PeakyNaka.png", "mouth": "Drink"},
  "#34": {"url": "#34 Bitcoin 3D HoodedNaka.png", "mouth": "Classic"},
  "#35": {"url": "#35 Melancholia Keeper RadioNaka.png", "mouth": "Pipe"},
  "#36": {"url": "#36 Volcano Blaine PeakyNaka.png", "mouth": "Classic"},
  "#37": {"url": "#37 Gox 3D HairNaka.png", "mouth": "Drink"},
  "#38": {"url": "#38 CP Keeper PeakyNaka.png", "mouth": "Pepetown"},
  "#39": {"url": "#39 Redputin Dank KingNaka.png", "mouth": "Classic"},
  "#40": {"url": "#40 Moon Sun CapNaka.png", "mouth": "Classic"},
  "#41": {"url": "#41 Moon Classic ClubNaka.png", "mouth": "Classic"},
  "#42": {"url": "#42 Homer Sun Naka.png", "mouth": "Pepetown"},
  "#43": {"url": "#43 Bitcoin Frogbus RadioNaka.png", "mouth": "Classic"},
  "#44": {"url": "#44 RLK 3D Naka.png", "mouth": "Classic"},
  "#45": {"url": "#45 Moon Dank MinerNaka.png", "mouth": "Pepejointsph"},
  "#46": {"url": "#46 Mondrian Keeper HairNaka.png", "mouth": "Pepeomuerte"},
  "#47": {"url": "#47 Djpepe Blaine KingNaka.png", "mouth": "Drink"},
  "#48": {"url": "#48 Hairpepe Jihan Naka.png", "mouth": "Classic"},
  "#49": {"url": "#49 Basquiat Blaine HairNaka.png", "mouth": "Pepetown"},
  "#50": {"url": "#50 Moon Frogbus HairNaka.png", "mouth": "Classic"},
  "#51": {"url": "#51 CP Keeper RadioNaka.png", "mouth": "Pepetown"},
  "#52": {"url": "#52 Mondrian FSB CapNaka.png", "mouth": "Drink"},
  "#53": {"url": "#53 Djpepe 3D PeakyNaka.png", "mouth": "Pepejointsph"},
  "#54": {"url": "#54 Djpepe Pepecash CapNaka.png", "mouth": "Classic"},
  "#55": {"url": "#55 Gox Dank KingNaka.png", "mouth": "Drink"},
  "#56": {"url": "#56 Volcano Jihan CapNaka.png", "mouth": "Classic"},
  "#57": {"url": "#57 Bitcoin FSB MinerNaka.png", "mouth": "Classic"},
  "#58": {"url": "#58 Basquiat Frogbus ClubNaka.png", "mouth": "Classic"},
  "#59": {"url": "#59 RLK Classic CapNaka.png", "mouth": "Pepejointsph"},
  "#60": {"url": "#60 Basquiat Dank PeakyNaka.png", "mouth": "Pepejointsph"},
  "#61": {"url": "#61 Redputin FSB ClubNaka.png", "mouth": "Pepetown"},
  "#62": {"url": "#62 Modern Blaine RadioNaka.png", "mouth": "Pepejointsph"},
  "#63": {"url": "#63 Djpepe Keeper KekLordNaka.png", "mouth": "Classic"},
  "#64": {"url": "#64 Gox Keeper Naka.png", "mouth": "Pepetown"},
  "#65": {"url": "#65 Modern 3D RadioNaka.png", "mouth": "Pepeomuerte"},
  "#66": {"url": "#66 Homer Frogbus PeakyNaka.png", "mouth": "Classic"},
  "#67": {"url": "#67 Homer Jihan HairNaka.png", "mouth": "Classic"},
  "#68": {"url": "#68 CP Sun RadioNaka.png", "mouth": "Pipe"},
  "#69": {"url": "#69 RLK Frogbus KekLordNaka.png", "mouth": "Classic"},
  "#70": {"url": "#70 Gox Blaine HoodedNaka.png", "mouth": "Pepeomuerte"},
  "#71": {"url": "#71 Hairpepe Classic PeakyNaka.png", "mouth": "Pepeomuerte"},
  "#72": {"url": "#72 Moon Pepecash HairNaka.png", "mouth": "Pepejointsph"},
  "#73": {"url": "#73 Moon Dank ClubNaka.png", "mouth": "Drink"},
  "#74": {"url": "#74 RLK Dank KekLordNaka.png", "mouth": "Pepejointsph"},
  "#75": {"url": "#75 Modern Keeper CapNaka.png", "mouth": "Pepetown"},
  "#76": {"url": "#76 Volcano Blaine ClubNaka.png", "mouth": "Pepeomuerte"},
  "#77": {"url": "#77 Homer Pepecash Naka.png", "mouth": "Pepeomuerte"},
  "#78": {"url": "#78 Melancholia Pepecash KingNaka.png", "mouth": "Classic"},
  "#79": {"url": "#79 Redputin Blaine HairNaka.png", "mouth": "Pepejointsph"},
  "#80": {"url": "#80 RLK Keeper ClubNaka.png", "mouth": "Pepejointsph"},
  "#81": {"url": "#81 Hairpepe 3D RadioNaka.png", "mouth": "Classic"},
  "#82": {"url": "#82 RLK Classic PeakyNaka.png", "mouth": "Classic"},
  "#83": {"url": "#83 Bitcoin Pepecash PeakyNaka.png", "mouth": "Drink"},
  "#84": {"url": "#84 Volcano Pepecash KingNaka.png", "mouth": "Pepetown"},
  "#85": {"url": "#85 Melancholia 3D RadioNaka.png", "mouth": "Drink"},
  "#86": {"url": "#86 Redputin Blaine MinerNaka.png", "mouth": "Classic"},
  "#87": {"url": "#87 Homer Classic RadioNaka.png", "mouth": "Drink"},
  "#88": {"url": "#88 Hairpepe Dank CapNaka.png", "mouth": "Classic"},
  "#89": {"url": "#89 Mondrian Jihan MinerNaka.png", "mouth": "Drink"},
  "#90": {"url": "#90 RLK FSB HoodedNaka.png", "mouth": "Drink"},
  "#91": {"url": "#91 RLK FSB KingNaka.png", "mouth": "Classic"},
  "#92": {"url": "#92 Modern FSB KekLordNaka.png", "mouth": "Classic"},
  "#93": {"url": "#93 Mondrian Dank KingNaka.png", "mouth": "Pepejointsph"},
  "#94": {"url": "#94 Place Keeper PeakyNaka.png", "mouth": "Pepeomuerte"},
  "#95": {"url": "#95 Place Classic MinerNaka.png", "mouth": "Drink"},
  "#96": {"url": "#96 Mondrian Classic MinerNaka.png", "mouth": "Classic"},
  "#97": {"url": "#97 Hairpepe FSB ClubNaka.png", "mouth": "Pepeomuerte"},
  "#98": {"url": "#98 Gox 3D CapNaka.png", "mouth": "Pepeomuerte"},
  "#99": {"url": "#99 Volcano Classic KingNaka.png", "mouth": "Classic"},
  "#100": {"url": "#100 Moon Jihan HoodedNaka.png", "mouth": "Classic"},
  "#101": {"url": "#101 RLK Dank PeakyNaka.png", "mouth": "Pipe"},
  "#102": {"url": "#102 Gox Dank RadioNaka.png", "mouth": "Classic"},
  "#103": {"url": "#103 Hairpepe Keeper HairNaka.png", "mouth": "Pipe"},
  "#104": {"url": "#104 Djpepe FSB RadioNaka.png", "mouth": "Drink"},
  "#105": {"url": "#105 Djpepe Pepecash HoodedNaka.png", "mouth": "Drink"},
  "#106": {"url": "#106 Melancholia Sun PeakyNaka.png", "mouth": "Pipe"},
  "#107": {"url": "#107 Volcano 3D CapNaka.png", "mouth": "Pepejointsph"},
  "#108": {"url": "#108 Mondrian Keeper ClubNaka.png", "mouth": "Classic"},
  "#109": {"url": "#109 Mondrian 3D Naka.png", "mouth": "Pepetown"},
  "#110": {"url": "#110 Hairpepe Pepecash Naka.png", "mouth": "Drink"},
  "#111": {"url": "#111 Redputin Jihan HoodedNaka.png", "mouth": "Classic"},
  "#112": {"url": "#112 Redputin 3D HoodedNaka.png", "mouth": "Classic"},
  "#113": {"url": "#113 Homer Dank HairNaka.png", "mouth": "Pepeomuerte"},
  "#114": {"url": "#114 Djpepe FSB ClubNaka.png", "mouth": "Pepejointsph"},
  "#115": {"url": "#115 Basquiat Classic CapNaka.png", "mouth": "Drink"},
  "#116": {"url": "#116 Mondrian Classic RadioNaka.png", "mouth": "Pepejointsph"},
  "#117": {"url": "#117 Redputin Blaine ClubNaka.png", "mouth": "Classic"},
  "#118": {"url": "#118 Bitcoin Blaine CapNaka.png", "mouth": "Classic"},
  "#119": {"url": "#119 Bitcoin Frogbus KingNaka.png", "mouth": "Classic"},
  "#120": {"url": "#120 Melancholia Blaine MinerNaka.png", "mouth": "Drink"},
  "#121": {"url": "#121 Moon Dank Naka.png", "mouth": "Pepetown"},
  "#122": {"url": "#122 Volcano FSB RadioNaka.png", "mouth": "Pepejointsph"},
  "#123": {"url": "#123 Basquiat Keeper KingNaka.png", "mouth": "Classic"},
  "#124": {"url": "#124 Volcano FSB MinerNaka.png", "mouth": "Classic"},
  "#125": {"url": "#125 Bitcoin FSB PeakyNaka.png", "mouth": "Pipe"},
  "#126": {"url": "#126 Basquiat Jihan RadioNaka.png", "mouth": "Classic"},
  "#127": {"url": "#127 Modern Jihan MinerNaka.png", "mouth": "Classic"},
  "#128": {"url": "#128 Djpepe Blaine Naka.png", "mouth": "Classic"},
  "#129": {"url": "#129 Basquiat Sun RadioNaka.png", "mouth": "Pepeomuerte"},
  "#130": {"url": "#130 RLK Classic HairNaka.png", "mouth": "Classic"},
  "#131": {"url": "#131 Mondrian Pepecash RadioNaka.png", "mouth": "Drink"},
  "#132": {"url": "#132 Volcano Pepecash RadioNaka.png", "mouth": "Pepeomuerte"},
  "#133": {"url": "#133 Modern Jihan HairNaka.png", "mouth": "Classic"},
  "#134": {"url": "#134 Djpepe Dank PeakyNaka.png", "mouth": "Classic"},
  "#135": {"url": "#135 Modern 3D ClubNaka.png", "mouth": "Pepejointsph"},
  "#136": {"url": "#136 Basquiat FSB HoodedNaka.png", "mouth": "Classic"},
  "#137": {"url": "#137 Basquiat Keeper KekLordNaka.png", "mouth": "Pepeomuerte"},
  "#138": {"url": "#138 Mondrian Jihan KingNaka.png", "mouth": "Classic"},
  "#139": {"url": "#139 CP Classic HoodedNaka.png", "mouth": "Pipe"},
  "#140": {"url": "#140 Modern Classic Naka.png", "mouth": "Pepetown"},
  "#141": {"url": "#141 Volcano Classic HoodedNaka.png", "mouth": "Classic"},
  "#142": {"url": "#142 Redputin Jihan KingNaka.png", "mouth": "Classic"},
  "#143": {"url": "#143 RLK Blaine ClubNaka.png", "mouth": "Drink"},
  "#144": {"url": "#144 Basquiat Blaine Naka.png", "mouth": "Pipe"},
  "#145": {"url": "#145 Redputin 3D PeakyNaka.png", "mouth": "Pepeomuerte"},
  "#146": {"url": "#146 CP Jihan ClubNaka.png", "mouth": "Classic"},
  "#147": {"url": "#147 Gox Sun PeakyNaka.png", "mouth": "Pepetown"},
  "#148": {"url": "#148 Mondrian Frogbus Naka.png", "mouth": "Classic"},
  "#149": {"url": "#149 Volcano Keeper Naka.png", "mouth": "Pepeomuerte"},
  "#150": {"url": "#150 Gox Blaine RadioNaka.png", "mouth": "Pipe"},
  "#151": {"url": "#151 Redputin 3D HairNaka.png", "mouth": "Pepetown"},
  "#152": {"url": "#152 Hairpepe Sun MinerNaka.png", "mouth": "Classic"},
  "#153": {"url": "#153 Melancholia Frogbus HoodedNaka.png", "mouth": "Classic"},
  "#154": {"url": "#154 RLK Pepecash CapNaka.png", "mouth": "Pepetown"},
  "#155": {"url": "#155 CP Pepecash HairNaka.png", "mouth": "Pipe"},
  "#156": {"url": "#156 Redputin Classic Naka.png", "mouth": "Classic"},
  "#157": {"url": "#157 Volcano Frogbus KekLordNaka.png", "mouth": "Classic"},
  "#158": {"url": "#158 Homer Blaine HoodedNaka.png", "mouth": "Pepejointsph"},
  "#159": {"url": "#159 Place Dank HoodedNaka.png", "mouth": "Classic"},
  "#160": {"url": "#160 Moon Frogbus Naka.png", "mouth": "Classic"},
  "#161": {"url": "#161 Modern Sun KekLordNaka.png", "mouth": "Pepejointsph"},
  "#162": {"url": "#162 Moon Pepecash MinerNaka.png", "mouth": "Pipe"},
  "#163": {"url": "#163 Hairpepe Blaine CapNaka.png", "mouth": "Pepetown"},
  "#164": {"url": "#164 Melancholia Sun KingNaka.png", "mouth": "Classic"},
  "#165": {"url": "#165 Volcano 3D MinerNaka.png", "mouth": "Pepetown"},
  "#166": {"url": "#166 Hairpepe Dank RadioNaka.png", "mouth": "Pepejointsph"},
  "#167": {"url": "#167 Redputin Pepecash KekLordNaka.png", "mouth": "Classic"},
  "#168": {"url": "#168 Modern Blaine HoodedNaka.png", "mouth": "Classic"},
  "#169": {"url": "#169 Basquiat 3D KingNaka.png", "mouth": "Pepejointsph"},
  "#170": {"url": "#170 Place FSB KekLordNaka.png", "mouth": "Pepeomuerte"},
  "#171": {"url": "#171 Volcano Keeper CapNaka.png", "mouth": "Drink"},
  "#172": {"url": "#172 Melancholia Dank ClubNaka.png", "mouth": "Pepetown"},
  "#173": {"url": "#173 Redputin Jihan CapNaka.png", "mouth": "Classic"},
  "#174": {"url": "#174 Gox Sun KekLordNaka.png", "mouth": "Pepetown"},
  "#175": {"url": "#175 Bitcoin Dank HairNaka.png", "mouth": "Pepejointsph"},
  "#176": {"url": "#176 Melancholia Sun CapNaka.png", "mouth": "Drink"},
  "#177": {"url": "#177 Place Dank CapNaka.png", "mouth": "Pepetown"},
  "#178": {"url": "#178 HairPepe Keeper KekLordNaka.png", "mouth": "Pepetown"},
  "#179": {"url": "#179 Gox Classic KingNaka.png", "mouth": "Drink"},
  "#180": {"url": "#180 Moon Jihan RadioNaka.png", "mouth": "Classic"},
  "#181": {"url": "#181 Bitcoin Keeper ClubNaka.png", "mouth": "Pepeomuerte"},
  "#182": {"url": "#182 Bitcoin Frogbus HoodedNaka.png", "mouth": "Classic"},
  "#183": {"url": "#183 Modern Sun ClubNaka.png", "mouth": "Pepetown"},
  "#184": {"url": "#184 Basquiat Blaine PeakyNaka.png", "mouth": "Drink"},
  "#185": {"url": "#185 Volcano Dank Naka.png", "mouth": "Classic"},
  "#186": {"url": "#186 Bitcoin Jihan HairNaka.png", "mouth": "Classic"},
  "#187": {"url": "#187 Place Sun MinerNaka.png", "mouth": "Pepejointsph"},
  "#188": {"url": "#188 Basquiat Classic Naka.png", "mouth": "Pipe"},
  "#189": {"url": "#189 Hairpepe Jihan PeakyNaka.png", "mouth": "Classic"},
  "#190": {"url": "#190 Mondrian Pepecash ClubNaka.png", "mouth": "Pepejointsph"},
  "#191": {"url": "#191 Gox Blaine MinerNaka.png", "mouth": "Pepetown"},
  "#192": {"url": "#192 CP Sun CapNaka.png", "mouth": "Pepeomuerte"},
  "#193": {"url": "#193 Place 3D HoodedNaka.png", "mouth": "Classic"},
  "#194": {"url": "#194 RLK 3D HairNaka.png", "mouth": "Pipe"},
  "#195": {"url": "#195 Djpepe Dank Naka.png", "mouth": "Pepeomuerte"},
  "#196": {"url": "#196 Modern FSB PeakyNaka.png", "mouth": "Pepeomuerte"},
  "#197": {"url": "#197 Basquiat FSB HairNaka.png", "mouth": "Pepeomuerte"},
  "#198": {"url": "#198 Djpepe 3D CapNaka.png", "mouth": "Pepeomuerte"},
  "#199": {"url": "#199 Mondrian Frogbus PeakyNaka.png", "mouth": "Classic"},
  "#200": {"url": "#200 Homer Classic KekLordNaka.png", "mouth": "Pepejointsph"},
  "#201": {"url": "#201 CP Blaine PeakyNaka.png", "mouth": "Pepejointsph"},
  "#202": {"url": "#202 Hairpepe FSB KekLordNaka.png", "mouth": "Pepetown"},
  "#203": {"url": "#203 Moon 3D KingNaka.png", "mouth": "Pepetown"},
  "#204": {"url": "#204 Homer Blaine CapNaka.png", "mouth": "Pepeomuerte"},
  "#205": {"url": "#205 Basquiat Frogbus MinerNaka.png", "mouth": "Classic"},
  "#206": {"url": "#206 RLK Keeper MinerNaka.png", "mouth": "Pepetown"},
  "#207": {"url": "#207 Hairpepe Blaine KingNaka.png", "mouth": "Pepetown"},
  "#208": {"url": "#208 Homer Keeper MinerNaka.png", "mouth": "Classic"},
  "#209": {"url": "#209 Homer Dank MinerNaka.png", "mouth": "Pepetown"},
  "#210": {"url": "#210 Place Classic ClubNaka.png", "mouth": "Classic"},
  "#211": {"url": "#211 CP Dank ClubNaka.png", "mouth": "Classic"},
  "#212": {"url": "#212 Gox Dank KekLordNaka.png", "mouth": "Classic"},
  "#213": {"url": "#213 Place Jihan RadioNaka.png", "mouth": "Classic"},
  "#214": {"url": "#214 Moon FSB CapNaka.png", "mouth": "Classic"},
  "#215": {"url": "#215 Bitcoin Pepecash Naka.png", "mouth": "Pepetown"},
  "#216": {"url": "#216 RLK Jihan MinerNaka.png", "mouth": "Classic"},
  "#217": {"url": "#217 Place FSB HairNaka.png", "mouth": "Classic"},
  "#218": {"url": "#218 Redputin Frogbus RadioNaka.png", "mouth": "Classic"},
  "#219": {"url": "#219 Place 3D CapNaka.png", "mouth": "Classic"},
  "#220": {"url": "#220 HairPepe Sun KingNaka.png", "mouth": "Drink"},
  "#221": {"url": "#221 Place Jihan ClubNaka.png", "mouth": "Classic"},
  "#222": {"url": "#222 Gox Pepecash MinerNaka.png", "mouth": "Drink"},
  "#223": {"url": "#223 Melancholia Frogbus KekLordNaka.png", "mouth": "Classic"},
  "#224": {"url": "#224 CP 3D KingNaka.png", "mouth": "Pepeomuerte"},
  "#225": {"url": "#225 Moon Keeper PeakyNaka.png", "mouth": "Classic"},
  "#226": {"url": "#226 CP FSB HoodedNaka.png", "mouth": "Pepetown"},
  "#227": {"url": "#227 CP Blaine KekLordNaka.png", "mouth": "Pepejointsph"},
  "#228": {"url": "#228 Djpepe Frogbus ClubNaka.png", "mouth": "Classic"},
  "#229": {"url": "#229 Bitcoin 3D ClubNaka.png", "mouth": "Pepetown"},
  "#230": {"url": "#230 Mondrian Sun HairNaka.png", "mouth": "Drink"},
  "#231": {"url": "#231 RLK Frogbus KingNaka.png", "mouth": "Classic"},
  "#232": {"url": "#232 CP Pepecash MinerNaka.png", "mouth": "Pepejointsph"},
  "#233": {"url": "#233 Mondrian Jihan PeakyNaka.png", "mouth": "Classic"},
  "#234": {"url": "#234 Moon Classic KekLordNaka.png", "mouth": "Pepeomuerte"},
  "#235": {"url": "#235 RLK Pepecash RadioNaka.png", "mouth": "Classic"},
  "#236": {"url": "#236 Homer FSB KingNaka.png", "mouth": "Drink"},
  "#237": {"url": "#237 CP FSB KingNaka.png", "mouth": "Pepejointsph"},
  "#238": {"url": "#238 Melancholia FSB CapNaka.png", "mouth": "Pepeomuerte"},
  "#239": {"url": "#239 Gox Classic ClubNaka.png", "mouth": "Pepetown"},
  "#240": {"url": "#240 Modern Frogbus HairNaka.png", "mouth": "Classic"},
  "#241": {"url": "#241 Bitcoin Keeper KingNaka.png", "mouth": "Pepeomuerte"},
  "#242": {"url": "#242 RedPutin FSB Naka.png", "mouth": "Classic"},
  "#243": {"url": "#243 Homer 3D ClubNaka.png", "mouth": "Drink"},
  "#244": {"url": "#244 Djpepe Jihan CapNaka.png", "mouth": "Drink"},
  "#245": {"url": "#245 Moon Sun HoodedNaka.png", "mouth": "Pipe"},
  "#246": {"url": "#246 Basquiat 3D CapNaka.png", "mouth": "Classic"},
  "#247": {"url": "#247 Volcano Keeper HoodedNaka.png", "mouth": "Pepetown"},
  "#248": {"url": "#248 Homer Frogbus RadioNaka.png", "mouth": "Classic"},
  "#249": {"url": "#249 Gox FSB HairNaka.png", "mouth": "Classic"},
  "#250": {"url": "#250 Homer Keeper HoodedNaka.png", "mouth": "Pepejointsph"},
  "#251": {"url": "#251 RedPutin Frogbus CapNaka.png", "mouth": "Classic"},
  "#252": {"url": "#252 Gox Frogbus CapNaka.png", "mouth": "Classic"},
  "#253": {"url": "#253 Hairpepe Pepecash HairNaka.png", "mouth": "Classic"},
  "#254": {"url": "#254 Basquiat Sun ClubNaka.png", "mouth": "Drink"},
  "#255": {"url": "#255 Djpepe Classic HairNaka.png", "mouth": "Drink"},
  "#256": {"url": "#256 Mondrian Frogbus CapNaka.png", "mouth": "Classic"},
  "#257": {"url": "#257 Basquiat Keeper MinerNaka.png", "mouth": "Drink"},
  "#258": {"url": "#258 Djpepe Sun HoodedNaka.png", "mouth": "Drink"},
  "#259": {"url": "#259 Basquiat Pepecash HoodedNaka.png", "mouth": "Pipe"},
  "#260": {"url": "#260 CP Frogbus Naka.png", "mouth": "Classic"},
  "#261": {"url": "#261 Mondrian Pepecash KekLordNaka.png", "mouth": "Classic"},
  "#262": {"url": "#262 Place Sun KekLordNaka.png", "mouth": "Pepeomuerte"},
  "#263": {"url": "#263 Bitcoin Jihan CapNaka.png", "mouth": "Classic"},
  "#264": {"url": "#264 Mondrian Pepecash HoodedNaka.png", "mouth": "Pepetown"},
  "#265": {"url": "#265 Place Frogbus HairNaka.png", "mouth": "Classic"},
  "#266": {"url": "#266 Homer 3D CapNaka.png", "mouth": "Pepetown"},
  "#267": {"url": "#267 Homer Frogbus KingNaka.png", "mouth": "Classic"},
  "#268": {"url": "#268 Volcano Jihan HoodedNaka.png", "mouth": "Classic"},
  "#269": {"url": "#269 Basquiat Pepecash CapNaka.png", "mouth": "Pepeomuerte"},
  "#270": {"url": "#270 Volcano Sun HairNaka.png", "mouth": "Classic"},
  "#271": {"url": "#271 Volcano Sun ClubNaka.png", "mouth": "Pepejointsph"},
  "#272": {"url": "#272 Place Keeper RadioNaka.png", "mouth": "Pepeomuerte"},
  "#273": {"url": "#273 Mondrian Blaine KekLordNaka.png", "mouth": "Drink"},
  "#274": {"url": "#274 Moon Keeper KingNaka.png", "mouth": "Classic"},
  "#275": {"url": "#275 Place Jihan Naka.png", "mouth": "Classic"},
  "#276": {"url": "#276 RLK Sun RadioNaka.png", "mouth": "Pepetown"},
  "#277": {"url": "#277 Melancholia Pepecash KekLordNaka.png", "mouth": "Pepetown"},
  "#278": {"url": "#278 Modern Keeper Naka.png", "mouth": "Drink"},
  "#279": {"url": "#279 Modern Dank CapNaka.png", "mouth": "Pepejointsph"},
  "#280": {"url": "#280 Moon FSB RadioNaka.png", "mouth": "Classic"},
  "#281": {"url": "#281 CP Dank MinerNaka.png", "mouth": "Pepeomuerte"},
  "#282": {"url": "#282 Djpepe Classic RadioNaka.png", "mouth": "Classic"},
  "#283": {"url": "#283 Bitcoin Blaine RadioNaka.png", "mouth": "Classic"},
  "#284": {"url": "#284 Melancholia Classic HairNaka.png", "mouth": "Pepetown"},
  "#285": {"url": "#285 Djpepe Frogbus MinerNaka.png", "mouth": "Classic"},
  "#286": {"url": "#286 Volcano Frogbus PeakyNaka.png", "mouth": "Classic"},
  "#287": {"url": "#287 RLK Blaine Naka.png", "mouth": "Pepetown"},
  "#288": {"url": "#288 Place Sun KingNaka.png", "mouth": "Pepetown"},
  "#289": {"url": "#289 Gox Jihan PeakyNaka.png", "mouth": "Classic"},
  "#290": {"url": "#290 Djpepe Keeper HairNaka.png", "mouth": "Pepetown"},
  "#291": {"url": "#291 Melancholia FSB Naka.png", "mouth": "Pepeomuerte"},
  "#292": {"url": "#292 Bitcoin Classic CapNaka.png", "mouth": "Pepetown"},
  "#293": {"url": "#293 Redputin 3D MinerNaka.png", "mouth": "Pepejointsph"},
  "#294": {"url": "#294 Melancholia Jihan ClubNaka.png", "mouth": "Classic"},
  "#295": {"url": "#295 Modern Pepecash PeakyNaka.png", "mouth": "Pepetown"},
  "#296": {"url": "#296 Place Blaine KingNaka.png", "mouth": "Pepejointsph"},
  "#297": {"url": "#297 Melancholia Jihan Naka.png", "mouth": "Drink"},
  "#298": {"url": "#298 Volcano Dank HairNaka.png", "mouth": "Pepetown"},
  "#299": {"url": "#299 RLK Sun HoodedNaka.png", "mouth": "Pepetown"},
  "#300": {"url": "#300 Melancholia FSB PeakyNaka.png", "mouth": "Pepetown"},
};
